import { useEffect } from 'react';

const useStorageListener = (handler: (event: StorageEvent) => void): void => {
  useEffect(() => {
    window.addEventListener('storage', handler);

    return () => {
      window.removeEventListener('storage', handler);
    };
  }, [handler]);
};

export default useStorageListener;
